const emailInput = document.getElementById('user_email');

emailInput?.addEventListener('input', () => {
  emailInput.value = emailInput.value.toLowerCase();
});
